// extracted by mini-css-extract-plugin
module.exports = {"noise":"ChordCanvas_noise__TK16K","shimmer":"ChordCanvas_shimmer__LE_Nw"};